import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles({
  root: {
    marginTop: '1em'
  },
  infoText: {
    marginBottom: '.5em',
    fontWeight: 500,
    color: '#00000099',
    fontSize: '1.2em'
  }
})
